import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from 'formik';
import { Box, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Yup from '../../../utils/yup';
import { DocumentType } from '../../../config/DocumentType';
import { WmsType } from '../../../config/wms/wmsType';
import { AutoCompleteSelectUI, ButtonUI, FormErrorUI, FormLabelUI } from '../../Interface';
import masterDataService from '../../../service/masterData.service';
import { generateAutocompleteItems } from '../../../utils/helper';
import wmsBaseService from '../../../service/wms/wmsBase.service';

const wmsType = WmsType.Delivery;

const NewDelivery = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const ui = theme.palette.ui;

  const defaultHead = {
    companyId: null,
    whsCode: '',
  };

  const validationSchema = Yup.object().shape({
    companyId: Yup.number().required(),
    whsCode: Yup.string().required(),
  });

  const [autocompleteOptions, setAutoCompleteOptions] = useState({
    company: [],
    warehouse: [],
  });
  const [autocompleteData, setAutoCompleteData] = useState({
    company: [],
    warehouse: [],
  });

  const getInitData = async () => {
    const [company, warehouse] = await Promise.all([
      masterDataService.companyToForm(),
      masterDataService.warehouseToForm(),
    ]);

    setAutoCompleteData({
      company,
      warehouse,
    });

    setAutoCompleteOptions((prev) => ({
      ...prev,
      warehouse: generateAutocompleteItems(warehouse ?? [], 'code', 'code'),
    }));
  };

  useEffect(() => {
    getInitData();
  }, []);

  useEffect(() => {
    if (autocompleteData?.company?.length > 0) {
      const filteredCompany = autocompleteData.company.filter((company) => company.active && company.customer);

      setAutoCompleteOptions((prev) => ({
        ...prev,
        company: generateAutocompleteItems(filteredCompany, ['code', 'name'], 'id'),
      }));
    }
  }, [autocompleteData.company]);

  const handleSubmit = async (values) => {
    const response = await wmsBaseService.createData({
      ...values,
      wmsType,
      targetDocType: DocumentType.Delivery,
    });
    navigate(`../deliveryDoc/${response.id}`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, py: 4, px: 2, width: '100%' }}>
      <Formik
        initialValues={defaultHead}
        validationSchema={validationSchema}
        validateOnChange={false}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, errors, setFieldValue, isSubmitting }) => (
          <Form>
            <Field
              type="autocomplete"
              name="whsCode"
              component={AutoCompleteSelectUI}
              fullWidth
              label={<FormLabelUI text="Raktár" />}
              variant="standard"
              helperText={<FormErrorUI message={errors.whsCode} />}
              InputLabelProps={{ shrink: Boolean(values.whsCode) }}
              onChange={(_e, newVal) => setFieldValue('whsCode', newVal?.value ?? null)}
              selectedValue={values.whsCode}
              selectedLabelValue={
                autocompleteData?.warehouse?.find((warehouse) => warehouse.code === values.whsCode)?.code
              }
              dataset={autocompleteOptions?.warehouse}
            />

            <Field
              type="autocomplete"
              name="companyId"
              component={AutoCompleteSelectUI}
              fullWidth
              label={<FormLabelUI text="Vevő" />}
              variant="standard"
              helperText={<FormErrorUI message={errors.companyId} />}
              InputLabelProps={{ shrink: Boolean(values.companyId) }}
              onChange={(_e, newVal) => setFieldValue('companyId', newVal?.value ?? null)}
              selectedValue={values.companyId}
              selectedLabelValue={autocompleteData?.company?.find((company) => company.id === values.companyId)?.name}
              dataset={autocompleteOptions?.company}
            />

            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', py: 1 }}>
              <ButtonUI
                text="Indítás"
                className="flex gap-2 items-center"
                style={{ background: ui.addButton }}
                type={'submit'}
                disabled={isSubmitting}
              />
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default NewDelivery;
